import { fullUrl } from './util.js'

export const desktopUrl = fullUrl('/dl/desktop/' + navigator.platform)
export const buyMoreUrl = fullUrl('/app/buy')
